import {svg, html, css, LitElement} from 'lit';
import {LightDocumentObjectModelNexusComponent} from '../modules/light-document-object-model-nexus-component.js';
import {NexusComponent} from '../modules/nexus.component.js';
import {ColorModule} from '../modules/color.module';
import {ButtonWithDropdown} from "./button-with-dropdown.component";
import * as bootstrap from 'bootstrap';

export class NexusNestedCheckboxesContainerComponent extends LightDocumentObjectModelNexusComponent {
    static properties = {

    };

    checkboxes = null;
    nestableFormChecks = null;

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    setEventListeners() {

        /**
         * This would handle a bunch of cases:
         * - (1) check nested checkboxes when checking a nestable checkbox
         * - (2) uncheck nested checkboxes when unchecking a nestable checkbox
         *
         * - (3) make (all) collapsible checkboxes parent checkboxes indeterminate when unchecking a nestable checkbox
         */
        this.renderRoot.addEventListener('click', (event) => {
            let actualCheckboxCheckedState = null;
            let closestNestableFormCheck = event.target.closest('.nestable-form-check');

            // console.log(`closestNestableFormCheck`, closestNestableFormCheck);
            // get the parent node of the closest nestable form check
            if (
                closestNestableFormCheck
            ) {
                let actualCheckbox = closestNestableFormCheck.querySelector(`input[type="checkbox"]`);
                if (
                    actualCheckbox
                ) {
                    // console.log(`actualCheckbox`, actualCheckbox, 'checked? =>', actualCheckbox.checked);
                    // console.log(`actualCheckbox`, actualCheckbox, 'indeterminate? =>', actualCheckbox.indeterminate);
                    // actualCheckbox.checked;
                    actualCheckboxCheckedState = actualCheckbox.checked ? 'checked' : null;
                    actualCheckboxCheckedState = actualCheckbox.indeterminate ? 'indeterminate': actualCheckboxCheckedState;

                    // (3)
                    this.handleCollapsibleNestedCheckboxes(closestNestableFormCheck, actualCheckboxCheckedState);
                }

                let nextCollapse = closestNestableFormCheck.parentNode.querySelector(`.collapse-nested`);
                if (
                    nextCollapse
                ) {
                    let nestedCheckboxes = nextCollapse.querySelectorAll(`.nestable-form-check input[type="checkbox"]`);
                    if (
                        nestedCheckboxes
                    ) {
                        // console.log('nestedCheckboxes', nestedCheckboxes);
                        nestedCheckboxes.forEach((nestedCheckbox) => {
                            // console.log('nestedCheckbox', nestedCheckbox);
                            if (actualCheckboxCheckedState === 'checked') {
                                // (1)
                                nestedCheckbox.checked = true;
                            }
                            // (2)
                            if (actualCheckboxCheckedState === null) {
                                nestedCheckbox.checked = false;
                            }
                        });
                    } else {
                        console.log('no nestedCheckboxes');
                    }

                }
            }
        });
    }

    propagateStateUpwards(formCheck, state) {
        console.log('propagateStateUpwards', formCheck);
        // let parentCheck = formCheck
        //     .closest('.immediate-form-row')
        //     .closest('.collapse-nested')
        //     .parentElement
        //     .querySelector('.nestable-form-check')
        // ;

        let parentCheck = null;

        let closestImmediateFormRow = formCheck.parentElement.closest('.immediate-form-row');
        if (
            closestImmediateFormRow
        ) {
            let closestImmediateFormRowCollapse = closestImmediateFormRow.closest('.collapse-nested');
            if (
                closestImmediateFormRowCollapse
            ) {
                let closestImmediateFormRowCollapseParentElement = closestImmediateFormRowCollapse.parentElement;
                if (
                    closestImmediateFormRowCollapseParentElement
                ) {
                    let closestImmediateFormRowCollapseParentElementFormCheck = closestImmediateFormRowCollapseParentElement.querySelector('.nestable-form-check');
                    if (
                        closestImmediateFormRowCollapseParentElementFormCheck
                    ) {
                        parentCheck = closestImmediateFormRowCollapseParentElementFormCheck;
                    }
                }
            }
        }

        if (
            parentCheck
            &&
            formCheck !== parentCheck // not same
            &&
            formCheck.querySelector('input[type="checkbox"]')
        ) {
            console.log('"valid" formCheck', formCheck);
            console.log('and the parent check is:', parentCheck, '!');
            let parentImmediateFormRow = parentCheck.closest('.immediate-form-row');
            console.log(`parentImmediateFormRow`, parentImmediateFormRow);
            let parentImmediateFormRowParentElement = parentImmediateFormRow.parentElement;
            console.log(`parentImmediateFormRowParentElement`, parentImmediateFormRowParentElement);
            let parentImmediateFormRowParentElementImmediateFormRows =  parentImmediateFormRowParentElement.querySelectorAll(':scope > .immediate-form-row');
            console.log(`parentImmediateFormRowParentElementImmediateFormRows`, parentImmediateFormRowParentElementImmediateFormRows, parentImmediateFormRowParentElementImmediateFormRows.length);

            let parentCheckboxes = [];
            let checkedParentCheckboxes = [];
            let indeterminateParentCheckboxes = [];

            parentImmediateFormRowParentElementImmediateFormRows.forEach((
                parentImmediateFormRowParentElementImmediateFormRow
            ) => {
                let parentCheckbox = parentImmediateFormRowParentElementImmediateFormRow.querySelector(`input[type="checkbox"]`)
                parentCheckboxes.push(parentCheckbox);
                if (
                    parentCheckbox.checked === true
                ) {
                    checkedParentCheckboxes.push(parentCheckbox);
                }
                if (
                    parentCheckbox.indeterminate === true
                ) {
                    indeterminateParentCheckboxes.push(indeterminateParentCheckboxes);
                }
            });

            console.log(`parentCheckboxes`, parentCheckboxes, parentCheckboxes.length);
            console.log(`checkedParentCheckboxes`, checkedParentCheckboxes, checkedParentCheckboxes.length);
            console.log(`indeterminateParentCheckboxes`, indeterminateParentCheckboxes, indeterminateParentCheckboxes.length);
            let nullOrIndeterminate = null;
            if (
                checkedParentCheckboxes.length > 0
                &&
                parentCheckboxes.length > 0
                &&
                checkedParentCheckboxes.length <= parentCheckboxes.length
            ) {
                nullOrIndeterminate = 'indeterminate';
            }

            // todo: check if there are 'sibling' checkboxes at the parent level
            console.log('and the state WOULD be updated to:', state)
            let checkbox = parentCheck.querySelector('input[type="checkbox"]');
            if (
                checkbox
            ) {
                if (
                    state === 'indeterminate'
                ) {
                    checkbox.indeterminate = true;
                    checkbox.checked = false;
                    this.propagateStateUpwards(parentCheck, 'indeterminate');
                }
            }
            if (
                checkbox
            ) {
                if (
                    state === null
                ) {
                    checkbox.indeterminate = false;
                    checkbox.checked = false;
                    this.propagateStateUpwards(parentCheck, nullOrIndeterminate);
                }
            }
            if (
                checkbox
            ) {
                if (
                    state === 'checked'
                ) {
                    checkbox.indeterminate = false;
                    checkbox.checked = true;
                    this.propagateStateUpwards(parentCheck, 'checked');
                }
            }
        }
    }

    handleCollapsibleNestedCheckboxes(closestNestableFormCheck, actualCheckboxCheckedState) {
        console.log('handleCollapsibleNestedCheckboxes: closestNestableFormCheck', closestNestableFormCheck, '( i.e.: the clicked item ;) )');

        let immediateNestableFormChecks = null;
        let thereAreCheckboxesInCollapse = false;
        let closestCollapse = closestNestableFormCheck.closest(`.collapse-nested`);
        if (
            closestCollapse
        ) {
            console.log(`closestCollapse`, closestCollapse);
            let formRows = closestCollapse.querySelectorAll(':scope > .immediate-form-row');
            console.log('formRows', formRows);
            let checkboxesAtThisLevel = [];
            let checkedCheckboxesAtThisLevel = [];
            formRows.forEach((formRow) => {
                let checkbox = formRow.querySelector('input[type="checkbox"]');
                checkboxesAtThisLevel.push(checkbox);
                if (
                    checkbox.checked === true
                ) {
                    checkedCheckboxesAtThisLevel.push(checkbox);
                }
            });

            console.log('checkboxesAtThisLevel', checkboxesAtThisLevel, checkboxesAtThisLevel.length);
            console.log('checkedCheckboxesAtThisLevel', checkedCheckboxesAtThisLevel, checkedCheckboxesAtThisLevel.length);

            if (
                // at least 1 checkbox at this level
                checkboxesAtThisLevel.length > 0
                && // and
                checkedCheckboxesAtThisLevel.length !== checkboxesAtThisLevel.length
            ) {
                console.log('there is at least 1 checkbox at this level, and there is a difference between the number of checkboxes at this level and the amount of checked checkboxes at this level...');
            }

            if (
                // at least 1 checkbox at this level
                checkboxesAtThisLevel.length > 0
                && // and
                checkedCheckboxesAtThisLevel.length > 0
            ) {
                console.log('there is at least 1 checkbox at this level, and there is at least one checked checkbox at this level');
            }

            if (
                // at least 1 checkbox at this level
                checkboxesAtThisLevel.length > 0
                && // and
                checkedCheckboxesAtThisLevel.length < checkboxesAtThisLevel.length
            ) {
                console.log('there is at least 1 checkbox at this level, and the number of checked checkboxes at this level is smaller than the amount of total checkboxes at this level... ');
                // closestNestableFormCheck.indeterminate = true;
                // this.propagateStateUpwards(closestNestableFormCheck.closest('.nestable-form-check'), 'indeterminate');
            }

            if (
                // at least 1 checkbox at this level
                checkboxesAtThisLevel.length > 0
                && // and
                checkedCheckboxesAtThisLevel.length === 0
            ) {
                console.log('there is at least 1 checkbox at this level, and no checkboxes are (marked as) checked at this level');
                this.propagateStateUpwards(closestNestableFormCheck, null);
                // extra todo: there may be siblings of a parent level
            }

            if (
                // at least 1 checkbox at this level
                checkboxesAtThisLevel.length > 0
                && // and
                checkedCheckboxesAtThisLevel.length > 0
                &&
                checkedCheckboxesAtThisLevel.length < checkboxesAtThisLevel.length
            ) {
                console.log('there is at least 1 checkbox at this level, and there is at least one checked checkbox at this level, and the amount of checked checkboxes at this level is smaller than the total amount of checkboxes at this level... // This WOULD constitute an indeterminate state for all levels above this');
                this.propagateStateUpwards(closestNestableFormCheck, 'indeterminate');
            }

            if (
                // at least 1 checkbox at this level
                checkboxesAtThisLevel.length > 0
                && // and
                checkedCheckboxesAtThisLevel.length > 0
                &&
                checkedCheckboxesAtThisLevel.length === checkboxesAtThisLevel.length
            ) {
                console.log('there is at least 1 checkbox at this level, and there is at least one checked checkbox at this level, furthermore the amount of checked checkboxes is equal to the amount of amount of checkboxes; i.e: all checkboxes at this level WOULD be checked right now....');
                this.propagateStateUpwards(closestNestableFormCheck, 'checked');
            }
        }
    }

    firstUpdated() {
        super.firstUpdated();
        this.setEventListeners();
        // this.checkboxes = this.renderRoot.querySelectorAll('input[type="checkbox"]');
        // if (
        //     this.checkboxes
        // ) {
        //     this.checkboxes.forEach((checkbox) => {
        //         console.log('checkbox', checkbox);
        //     });
        // }
        this.nestableFormChecks = this.renderRoot.querySelectorAll('.nestable-form-check');
        if (
            this.nestableFormChecks
        ) {
            this.nestableFormChecks.forEach((nestableFormCheck) => {
                console.log('firstUpdated: nestableFormCheck', nestableFormCheck, nestableFormCheck.querySelector('input[type="checkbox"]').checked);
                if (
                    nestableFormCheck.querySelector('input[type="checkbox"]').checked === true
                ) {
                    this.triggerEventOnElement('click', nestableFormCheck.querySelector('input[type="checkbox"]'));
                }
            });
        }
    }

    /**
     *
     * @returns {*}
     */
    render() {
        return html``;
    }
}

customElements.define("nexus-nested-checkboxes-container", NexusNestedCheckboxesContainerComponent);
